module.exports = "https://www.gc-pro.gnp.com.mx/1471bfecc1632e77ec8d653efe72d250.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-4.png
// module id = 8149
// module chunks = 0